import React, { useEffect } from "react";

import { jaytrends } from "../../../utils/constants";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Milktheframer = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section
        className={`bg-black px-8 pt-40 md:pt-60 -mt-[1px] text-center  lg:px-16 md:pb-10`}
      >
        <div className=" md:w-[80%] pb-12 text-left ">
          <h2
            className={`text-[32px] md:text-[64px] text-white leading-[33px] lg:leading-[74.56px] font-semibold `}
          >
            JAYTRENDS -
          </h2>
          <p
            className={`text-[32px] md:text-[64px] text-white leading-[33px] lg:leading-[74.56px]`}
          >
            Brand Identity & Advertising for Streetwear/Fashion Brand
          </p>
        </div>
      </section>

      <section className="bg-black px-8 pb-12  -mt-[1px] lg:px-16 lg:pb-16">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="space-y-4 text-white">
            <h1 className="font-[400] text-[20px] leading-[30px] text-white/50 ">
              ABSTRACT
            </h1>
            <div className="h-[0.5px] bg-[#f5f5f5]" />
            <p className="font-[400] text-[20px] leading-[30px] ">
              The past year witnessed a huge influx of outfit brands, and
              because I always aim to make the brands that I work on stand out
              amongst competition, I created a timeless and flexible identity
              for JAYTRENDS.
            </p>
          </div>

          <div className="space-y-4 text-white">
            <h1 className="font-[400] text-[20px] leading-[30px] text-white/50 ">
              SERVICE
            </h1>
            <div className="h-[0.5px] bg-[#f5f5f5]" />
            <p className="font-[400] text-[20px] leading-[30px] ">
              Brand Identity Design
            </p>
          </div>

          <div className="space-y-4 text-white">
            <h1 className="font-[400] text-[20px] leading-[30px] text-white/50 ">
              CREDITS
            </h1>
            <div className="h-[0.5px] bg-[#f5f5f5]" />
            <p className="font-[400] text-[20px] leading-[30px] ">
              Art Direction: Temidayo Arowolo <br />
              Contribution: Daniel Owolabi, Omoolorun Goodness
            </p>
          </div>
        </div>
      </section>

      <section className="bg-black px-8  -mt-[1px] lg:px-16 md:pb-10">
        {jaytrends.map((image) => (
          <div key={image.id} className="">
            <LazyLoadImage
              src={image.img}
              effect="blur"
              className="w-full pb-4"
              alt={image.id}
            />
          </div>
        ))}
      </section>

      <div className="bg-black px-8  -mt-[1px] lg:px-16 md:pb-10">
        <div className="h-[0.5px] bg-[#f5f5f5]" />
      </div>
    </>
  );
};

export default Milktheframer;
